import React, { ChangeEventHandler } from 'react';
import { ButtonRowView } from '../../Buttons/ButtonRowView';

type TSelectPhotosProps = {
    /** Design version of the profile widget (`TWidget.version`). */
    version: number | undefined;
    label?: string;
    iconName?: string;
    handleChange: ChangeEventHandler;
};
const SelectPhotos = ({ version, label, iconName, handleChange }: TSelectPhotosProps) => {
    return (
        <label htmlFor="file">
            <ButtonRowView version={version} as="div" label={label} iconName={iconName} />
            <input
                id="file"
                type="file"
                accept=".png,.jpg,.gif,.webp,image/jpeg,image/gif,image/webp,image/png"
                onChange={handleChange}
                style={{ display: 'none' }}
            />
        </label>
    );
};
export { SelectPhotos };
